import React, {Component} from "react";
import './style.scss';
import OrdersContainer from "../../Redux/containers/OrdersContainer";
import DeliveryGroupsMapContainer from "../../Redux/containers/DeliveryGroupsMapContainer";
import TopToolbarContainer from "../../Redux/containers/TopToolbarContainer";
import Permissions from "../../Utils/Permissions/Permissions";
import {AppProvider} from "../../Components/Utils/AppContext";
import * as permissionTypes from "../../Utils/Permissions/PermissionTypes";
import CircularProgress from "@material-ui/core/CircularProgress";
import iconColors from "../../Utils/Icons/iconColors";
import 'react-reflex/styles.css';
import SnackbarContainer from "../../Redux/containers/SnackbarContainer";
import {isAuthenticated} from "../../Utils/Authentication";
import UrlParamsContainer from "../../Redux/containers/UrlParamsContainer";
import Direction from "../../Utils/Direction/Direction";
import {hotjar} from "react-hotjar";

class DeliveriesDashboard extends Component {
    state = {
        isLoadingPermissions: true,
        isLoadingAuthentication: true,
        direction: "rtl"
    };

    constructor(props) {
        super(props);

        this.uid = null;
        this.uid = null;
        this.permissions = new Permissions();
        this.iconColors = new iconColors();
    }

    componentWillMount() {
        this.initComponent();
    }

    async initComponent() {
        const uid = await this.checkAuthentication();
        hotjar.identify(uid, {bid: this.props.match.params.bid});

        this.initializePermissions();

        this.props.fetchOrders(this.props.match.params.bid);
        this.props.fetchUsers(this.props.match.params.bid);
        this.props.fetchBusiness(this.props.match.params.bid);
        this.props.fetchDistributionAreas(this.props.match.params.bid);
        this.props.fetchProfiles();

        setInterval(this.fetchOrdersAndUsers.bind(this), 5000);
        setInterval(this.fetchBusiness.bind(this), 20000);
        setInterval(this.fetchDistributionAreas.bind(this), 20000);
    }

    async fetchOrdersAndUsers() {
        this.props.fetchOrders(this.props.match.params.bid);
        this.props.fetchUsers(this.props.match.params.bid);
    }

    async fetchBusiness() {
        this.props.fetchBusiness(this.props.match.params.bid);
    }

    async fetchDistributionAreas() {
        this.props.fetchDistributionAreas(this.props.match.params.bid);
    }

    async initializePermissions() {
        this.setState({isLoadingPermissions: true});

        if (this.uid && this.props.match.params.bid)
            await this.permissions.init(this.uid, this.props.match.params.bid);

        this.setState({
            isLoadingPermissions: false
        });
    }

    async checkAuthentication() {
        const authentication = await isAuthenticated();

        if (authentication.isAuthenticated) {
            this.uid = authentication.uid;
            this.setState({isLoadingAuthentication: false})

            return authentication.uid;
        } else {
            this.props.history.push('/login');

            return undefined;
        }
    }

    render() {
        if (this.state.isLoadingPermissions ||
            this.state.isLoadingAuthentication ||
            !this.props.profilesFetched ||
            !this.props.businessFetched)
            return (
                <div className="loading-container">
                    <CircularProgress size={80} thickness={2}/>
                </div>
            );

        if (!this.permissions || !this.permissions.isPermitted(permissionTypes.VIEW_DELIVERY_DASHBOARD))
            return (
                <div className="page-wrapper">
                    <div>
                        אינך מורשה לעמוד זה
                    </div>
                </div>
            );

        return (
            <AppProvider value={{
                bid: this.props.match.params.bid,
                permissions: this.permissions,
                iconColors: this.iconColors,
                direction: this.state.direction
            }}>
                <Direction direction={this.state.direction} isApplyToBody={true}>
                    <div className="page-wrapper">
                        <div className="toolbar-wrapper">
                            <TopToolbarContainer match={this.props.match}/>
                        </div>

                        <div className="dashboard-content">
                            {this.permissions.isPermitted(permissionTypes.VIEW_ORDERS) ?
                                <div className="dashboard-component orders-container">
                                    <OrdersContainer match={this.props.match}/>
                                </div>
                                :
                                false
                            }
                            {this.permissions.isPermitted(permissionTypes.VIEW_MAP) ?
                                <div className="dashboard-component map-container">
                                    <DeliveryGroupsMapContainer match={this.props.match}/>
                                </div>
                                :
                                false
                            }
                        </div>
                    </div>
                    <SnackbarContainer/>
                </Direction>
                <UrlParamsContainer location={this.props.location} match={this.props.match}/>
            </AppProvider>
        );
    }
}

export default DeliveriesDashboard;